import React from 'react';
import { formatGold } from '../../utils/goldNotation';
import { donorRanking } from '../../utils/transparency';

const MEDAL_COLORS = ['text-yellow-400', 'text-gray-300', 'text-amber-600'];

const DonorRanking = ({ rows }) => {
  const ranking = donorRanking(rows);

  if (ranking.length === 0) {
    return <p className="text-gray-400 text-sm">Ninguém doou o prêmio ainda.</p>;
  }

  return (
    <div className="rounded-xl border border-white/10 overflow-hidden">
      <div className="grid grid-cols-[3rem_minmax(0,1fr)_7rem] gap-4 px-4 py-2 bg-white/5 text-gray-400 text-xs uppercase">
        <span>#</span><span>Doador</span><span className="text-right">Doado</span>
      </div>
      {ranking.map((row, index) => (
        <div key={row.recipientName} className="grid grid-cols-[3rem_minmax(0,1fr)_7rem] gap-4 items-center px-4 py-3 border-t border-white/5">
          <span className={`font-bold ${MEDAL_COLORS[index] || 'text-gray-500'}`}>{index + 1}º</span>
          <span className="text-white truncate">{row.recipientName}</span>
          <span className="text-purple-400 font-semibold text-right" title={Number(row.voluntary).toLocaleString('pt-BR')}>
            {formatGold(row.voluntary)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default DonorRanking;
